import type { FunctionComponent } from 'react';
import type { ConsumerStepId } from '../lib/steps';
import { ApplicationBeneficiariesStep } from './application-beneficiaries-step';
import { ApplicationHealthStep } from './application-health-step';
import { ApplicationMedicalStep } from './application-medical-step';
import { ApplicationPersonalStep } from './application-personal-step';
import { ApplicationReviewStep } from './application-review-step';
import { ApplicationStartStep } from './application-start-step';
import { BreakdownStep } from './breakdown-step';
import { CareSettingStep } from './care-setting-step';
import { ChangeStep } from './change-step';
import { CompareStep } from './compare-step';
import { CoverageStep } from './coverage-step';
import { ExistingPolicyStep } from './existing-policy-step';
import { HouseholdStep } from './household-step';
import { MedicaidStep } from './medicaid-step';
import { NoCareStep } from './no-care-step';
import { OptionsStep } from './options-step';
import { PaymentPreferenceStep } from './payment-preference-step';
import { PolicyTermsStep } from './policy-terms-step';
import { PremiumRangeStep } from './premium-range-step';
import { ReviewCheckoutStep } from './review-checkout-step';
import { ReviewStatusStep } from './review-status-step';
import { ReviewStep } from './review-step';
import { ReviewUploadStep } from './review-upload-step';
import { ScenarioStep } from './scenario-step';
import { SelfFundStep } from './self-fund-step';
import { SearchingStep } from './searching-step';
import { SettingStep } from './setting-step';
import type { ConsumerStepProps } from './step-props';
import { SubmittedStep } from './submitted-step';
import { WalkthroughStep } from './walkthrough-step';
import { WalkthroughSummaryStep } from './walkthrough-summary-step';

export const CONSUMER_STEP_COMPONENTS: Record<ConsumerStepId, FunctionComponent<ConsumerStepProps>> = {
  setting: SettingStep,
  household: HouseholdStep,
  scenario: ScenarioStep,
  'care-setting': CareSettingStep,
  'payment-preference': PaymentPreferenceStep,
  searching: SearchingStep,
  options: OptionsStep,
  coverage: CoverageStep,
  'policy-terms': PolicyTermsStep,
  compare: CompareStep,
  'premium-range': PremiumRangeStep,
  'existing-policy': ExistingPolicyStep,
  'review-upload': ReviewUploadStep,
  'review-checkout': ReviewCheckoutStep,
  'review-status': ReviewStatusStep,
  'self-fund': SelfFundStep,
  walkthrough: WalkthroughStep,
  'walkthrough-summary': WalkthroughSummaryStep,
  breakdown: BreakdownStep,
  'no-care': NoCareStep,
  medicaid: MedicaidStep,
  review: ReviewStep,
  change: ChangeStep,
  'application-start': ApplicationStartStep,
  'application-personal': ApplicationPersonalStep,
  'application-health': ApplicationHealthStep,
  'application-medical': ApplicationMedicalStep,
  'application-beneficiaries': ApplicationBeneficiariesStep,
  'application-review': ApplicationReviewStep,
  submitted: SubmittedStep,
};
